// VangalHeroSection.jsx
import React from "react";
import "./VangalHeroSection.css";

const VangalHeroSection = () => {
  return (
    <section className="vangal-hero-section anim anim-top">
      <div className="vangal-hero-overlay">
        <h1 className="vangal-hero-title anim anim-bottom">
          “Experience Nature’s Purest Form with Vangal Farms”
        </h1>
      </div>
    </section>
  );
};

export default VangalHeroSection;
